import { render } from "./LanguageToggle.vue?vue&type=template&id=2e8caec6"
import script from "./LanguageToggle.vue?vue&type=script&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&lang=js"
script.render = render

export default script